/* unplugin-vue-components disabled */import script from "./TopContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TopContent.vue?vue&type=script&setup=true&lang=js"

import "./TopContent.vue?vue&type=style&index=0&id=824db86e&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824db86e"]])

export default __exports__